import Api from '@vacationtracker/shared/services/api'

import type { FeatureRequestBoard } from '@vacationtracker/shared/types/feature-request'

export const openFeatureRequest = (board: FeatureRequestBoard = 'general'): Promise<void> => {
  // Opened before the request so the click's user activation covers it; Safari blocks tabs opened after an await.
  // Not 'noopener': that makes window.open return null, and the tab must be navigated once the URL arrives.
  const tab = window.open('', '_blank')
  if (tab) {
    tab.opener = null
  }

  return Api.get(`/core/feature-request-url?board=${board}`)
    .then((response: { url: string }) => {
      if (tab) {
        tab.location.href = response.url
      } else {
        window.open(response.url, '_blank', 'noopener,noreferrer')
      }
    })
    .catch(() => {
      tab?.close()
      const subject = encodeURIComponent('Feature Request')
      const body = encodeURIComponent('Tell us about the problem you are trying to solve, not only the solution.\n\n')
      // '_self': mailto hands off to the mail client without leaving the page, so no popup to block.
      window.open(`mailto:hello@vacationtracker.io?subject=${subject}&body=${body}`, '_self')
    })
}
